import Parse from "parse";

Parse.initialize("openinc-asew-wasser");
Parse.serverURL = "https://parse-wasser.apps.openinc.dev/parse";
